import React from 'react'
import Container from 'reactor/components/Grid/ContainerWithWidth'
import { makeStyles } from "@material-ui/core/styles"
import GridItem from 'reactor/components/Grid/GridItem'
import Button from 'reactor/components/Button'

export default function Summary(props) {

    const useStyles = makeStyles(theme => ({
        summaryStyle: {
            background: 'url(' + props.back + ') ,' + props.background,
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
            backgroundRepeat: 'no-repeat',
            padding:'0 0 16rem 0'
        },
        headingTitle: {
            fontWeight: '900',
            fontSize: '40px !important',
            color: props.color,
            marginBottom: '2rem',
            '@media (max-width: 1400px)': {
              fontSize: '36px !important',
            },
            '@media (max-width: 1200px)': {
              fontSize: '32px !important',
            },
            '@media (max-width: 992px)': {
              fontSize: '28px !important',
            },
            '@media (max-width: 768px)': {
              fontSize: '20px !important',
            },
            '@media (max-width: 576px)': {
              fontSize: '18px !important',
            },
          },
          headingSubtitle: {
            fontWeight: '500',
            fontSize: '20px !important',
            color: props.color,
            marginBottom: '32px',
            textAlign: 'justify',
            '@media (max-width: 1200px)': {
              fontSize: '18px !important',
              marginBottom: '28px',
            },
            '@media (max-width: 992px)': {
              fontSize: '16px !important',
              marginBottom: '24px',
            },
            '@media (max-width: 768px)': {
              fontSize: '14px !important',
              marginBottom: '20px',
            },
            '@media (max-width: 576px)': {
              fontSize: '12px !important',
              marginBottom: '16px',
            },
          },          
        notify: {
            fontWeight: '300',
            fontSize: '2.5rem',
            color: props.color
        }
    }));

    const classes = useStyles();

    return (
        <div className={`summary ${classes.summaryStyle}`}>
                {props.title && props.subtitle && props.image ?
                    <Container>
                        <GridItem md={7} xs={12} >
                            <h3 dangerouslySetInnerHTML={{__html: props.title}} className={classes.headingTitle}></h3>
                            <p dangerouslySetInnerHTML={{__html: props.subtitle}} className={classes.headingSubtitle}></p>
                        </GridItem>
                        <GridItem md={5} xs={12}>
                            <div className="summary__image" align="center">
                                <img src={props.image} alt="" className="img-fluid" />
                            </div>
                        </GridItem>
                    </Container>
                : props.title && props.subtitle ?
                    <Container block={"true"}>
                        <h3 dangerouslySetInnerHTML={{__html: props.title}} className={classes.headingTitle}></h3>
                        <p dangerouslySetInnerHTML={{__html: props.subtitle}} className={classes.headingSubtitle}></p>
                        {props.button ? <Button text="أطلب الآن" variant="contained" background="#FF3434" className="order-now" /> : ""}
                    </Container>
                : props.subtitle && props.image ?
                    <Container>
                        <GridItem sm={6} xs={12}>
                            <p dangerouslySetInnerHTML={{__html: props.subtitle}} className={classes.headingSubtitle}></p>
                        </GridItem>
                        <GridItem sm={6} xs={12}>
                            <div className="summary__image" align="center">
                                <img src={props.image} alt="" className="img-fluid" />
                            </div>
                        </GridItem>
                    </Container>
                : props.title && props.image ?
                    <Container>
                        <GridItem sm={6} xs={12}>
                            <h3 dangerouslySetInnerHTML={{__html: props.title}} className={classes.headingTitle}></h3>
                        </GridItem>
                        <GridItem sm={6} xs={12}>
                            <div className="summary__image" align="center">
                                <img src={props.image} alt="" className="img-fluid" />
                            </div>
                        </GridItem>
                    </Container>
                :
                    <Container block={"true"}>
                        <p dangerouslySetInnerHTML={{__html: props.subtitle}} className={classes.headingSubtitle}></p>
                    </Container>
                }

        </div>
    )
}